<template>
    <div style="height: 100%;overflow: hidden;">
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: "home"
    }
</script>

<style scoped>

</style>
